module.exports = __webpack_public_path__ + "img/keshavarzi.f6253f3c.png";